'use client'

import { shouldAutoRetry } from '../Utilities/errorAutoRetry'

import { useEffect } from 'react'

import ErrorPage from 'Clutch/Organisms/ErrorPage'

export default function CustomError({ error, reset }) {
  const autoRetry = shouldAutoRetry(error)

  useEffect(() => {
    if (autoRetry) reset()
  }, [autoRetry, reset])

  if (autoRetry) return false

  return <ErrorPage statusCode={500} />
}
